{{ itemAmountModel().totalAmount | number: '1.0-0' : 'de' }} {{ itemAmountModel().amountUnit }}
@if (itemAmountModel().contractDuration && itemAmountModel().contractDuration! > 0) {
  {{ 'SHARED.FOR_DURATION' | translate }}
  {{ itemAmountModel().contractDuration }}
  {{ 'SHARED.MONTHS' | translate }}
}
